import { axiosInstance } from "../common";

const ENDPOINT = `/image`;

export const uploadFileFromObject = async (file) => {
    const formData = new FormData();
    formData.append('image', file);
    return axiosInstance.post(ENDPOINT, formData).then(({ id }) => id)
}